<div class="toolbar-position border-bottom-1 surface-border">
  <div class="surface-b">
    <div class="container m-auto surface-toolbar">
      <p-toolbar class="ios-custom-toolbar">
        <div class="p-toolbar-group-start">
          <div>
            <img ngSrc="assets/img/logo-cefla.png" height="40" alt="" width="40" />
          </div>
          <div class="p-toolbar-group-start ml-4">
            <p-chip
              class="ios-custom-chip cursor-pointer mr-2"
              [class.selected]="checkRouteMatching('/licenses')"
              [label]="'LABELS.LICENSES' | translate"
              icon="fa-solid fa-folder-open"
              routerLink="/licenses"
            ></p-chip>
          </div>
        </div>
        <div class="p-toolbar-group-end flex">
          <!-- <button
            pButton
            type="button"
            (click)="routeTo('/profile-settings')"
            icon="fa fa-lg fa-user"
            class="p-button-rounded p-button-secondary p-button-text"
            [class.selected-route]="checkRouteMatching('/profile-settings')"
          ></button> -->
          <button
            pButton
            type="button"
            (click)="logout()"
            icon="fa fa-solid fa-right-from-bracket"
            class="p-button-rounded p-button-secondary p-button-text"
          ></button>
        </div>
      </p-toolbar>
    </div>
  </div>
</div>
